import { GlobalHeader, ProfileProps } from '@design-system/global-header';
import { useProfile } from '@phx-husky/use-profile';
import { useUserSession } from '@phx-husky/use-user-session';
import { navigate } from 'gatsby';
import React from 'react';

import { useAutocomplete } from '~/hooks/useAutocomplete';
import { UseLanguageSwitchHook } from '~/hooks/useLanguageSwitch';
import { headerMapper } from '~/mappers/header';
import {
  HeaderBasic,
  HeaderSplitterAdditionalData,
  HeaderWithSplitter,
  Profile,
} from '~/mappers/header/models';
import { gtmService } from '~/services/gtm';

const HeaderWrapWithProfile = ({
  headerBasic,
  headerWithSplitter,
  headerSplitterAdditionalData,
  languageSwitch,
  profile,
}: {
  headerBasic?: HeaderBasic | null;
  headerWithSplitter?: HeaderWithSplitter | null;
  headerSplitterAdditionalData?: HeaderSplitterAdditionalData;
  languageSwitch: ReturnType<UseLanguageSwitchHook>;
  profile?: Profile;
}) => {
  const { autocompleteState, getInputProps } = useAutocomplete();

  const mapped = headerMapper({
    headerBasic,
    headerWithSplitter,
    headerSplitterAdditionalData,
    languageSwitch,
    profile,
  });

  const { isSignedIn, signOut } = useUserSession();
  const { getUserName } = useProfile();

  return mapped ? (
    <GlobalHeader
      {...{
        ...mapped,
        profile: {
          ...mapped.profile,
          signedIn: isSignedIn(),
          handleSignOut: () => signOut(),
          handleLogIn: () => navigate(mapped.profile!.logIn.link),
          handleRegister: () => navigate(mapped.profile!.register.link),
          userName: getUserName().userName,
        } as ProfileProps,
        search: mapped.search
          ? {
              ...mapped.search,
              autocomplete: { autocompleteState, getInputProps },
            }
          : undefined,
        onClickNavItem: (value) => gtmService.emitHeaderMenuClick(value),
      }}
    />
  ) : null;
};

export default HeaderWrapWithProfile;
